import ActivityModal from "src/modules/Activity/ActivityModal";
import SystemTableActivityModal from "../Activity/SystemTableActivityModal";

export const MODALS = {
  activityModal: ActivityModal,
  systemTableActivityModal: SystemTableActivityModal,
};
